import {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {FormProvider} from 'react-hook-form';
import {WhosComingForm} from 'components/ReservationSettingsModal';
import {useGuestCountSubmit} from 'pages/Auth/hooks/useGuestCountSubmit';
import {StepHeading} from 'pages/InstantCheckIn/steps/StepParts';

type Props = {
  onDone: () => void;
  onTotalChange: (totalGuests: number) => void;
};

function FoundGuestCount({onDone, onTotalChange}: Props) {
  const {t} = useTranslation();
  const {formMethods, onSubmit, formProps} = useGuestCountSubmit({onDone});
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(function moveFocusToTheHeading() {
    rootRef.current
      ?.querySelector<HTMLElement>('[data-step-heading]')
      ?.focus({preventScroll: true});
  }, []);

  return (
    <div ref={rootRef}>
      <StepHeading lead={t('guest_count_check_lead')}>
        {t('instant_check_in.confirm_whos_coming')}
      </StepHeading>

      <FormProvider {...formMethods}>
        <WhosComingForm
          {...formProps}
          onSubmit={onSubmit}
          onTotalGuestsChange={onTotalChange}
          stickySubmit
        />
      </FormProvider>
    </div>
  );
}

export {FoundGuestCount};
